
import { Component, OnInit, Input, EventEmitter, Output, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { UserSessionService, OrderParms } from '../../../shared';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { OrderReceptionService } from '../order-reception/order-reception.service';
import { Router } from '@angular/router';
import { PrintComponent } from '../../../blocks/print-component/print-component';


@Component({
    selector: 'app-order-print',
    templateUrl: './order-print.component.html'
})
export class OrderPrintComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject<void>();
    orderParms: OrderParms = <OrderParms>{};
    orderserves: any[] = [];
    servesConditions: any[];

    selectedOrder: any;
    router: Router;
    autoPrint = false;
    dynamicComponent: any;
    @ViewChild('inpatientTeam') content: any;
    @ViewChild('printComponent', { static: true }) printComponent: PrintComponent;

    masterSerial: number;
    constructor(private orderReceptionService: OrderReceptionService,
        private userSession: UserSessionService,
        public translate: TranslateService) {
        // this.userSession.subscribeToKey$('Printed')
        // .pipe(takeUntil(this.ngUnsubscribe))
        // .subscribe(res => {
        //     if (res.returnFlag) {
        //       this.orders = res['data'];
        //       this.selectedOrder = {};

        //     }
        //   });
    }
    ngOnInit() {
        this.userSession.subscribeToKey$('OrderDetailPrint')
            .subscribe(key => {
                if (key.value) {
                    this.selectedOrder = key.value;
                    this.getOrderList();
                    this.autoPrint = true;
                }
            });
        this.userSession.subscribeToKey$('MASTERORDERSERIAL')
            .subscribe(key => {
                if (key.value) {
                    this.masterSerial = key.value;
                    this.displayPrintOrder(this.masterSerial);
                }
            });
    }

    getOrderList() {
        if (this.selectedOrder) {
            this.orderserves = [];
            this.servesConditions = [];
            let x = <OrderParms>{}
            x.serial = this.selectedOrder.orderMasterSerial,
                x.serviceType = this.selectedOrder.type
            x.visitSerial = this.selectedOrder.visitSerial
            x.orderDetailSerial = this.selectedOrder.orderDetailSerial
            x.serviceCode = this.selectedOrder.code
            x['orderPrintFlag'] = this.selectedOrder.orderPrintFlag
            this.orderReceptionService.orderDetail(x)
                .pipe(
                    takeUntil(this.ngUnsubscribe))
                .subscribe(res => {
                    if (res && res.data) {
                        this.orderserves = res['data'];
                    }
                    if (res && res.data1) {
                        this.servesConditions = res['data1'];
                    }
                },
                    error => console.log(error),
                    () => {
                        setTimeout(() => { if (this.printComponent) { this.printComponent.PrintView() } }, 200);
                    }
                );

        }

    }

    orderPrintData: any[] = [];
    displayPrintOrder(orderSerial: any): any {
        if (orderSerial && orderSerial > 0) {
            this.orderPrintData = [];
            this.orderReceptionService.getRegPatOrderDetailsPrint(orderSerial)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                    res => {
                        if (res && res.data && res.data.length > 0) {
                            this.orderPrintData = res.data;
                        }
                    },
                    err => console.error(err),
                    () => {
                        setTimeout(() => { if (this.printComponent) { this.printComponent.PrintView() } }, 200);
                    });
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.autoPrint = false;
    }

}

